import React from "react";

export default function FichaReferenciaModal({ ficha, fotoUsuario = null, onClose }) {
  if (!ficha) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 flex items-end sm:items-center justify-center p-0 sm:p-4" data-testid="ficha-modal" onClick={onClose}>
      <div className="bg-white w-full sm:max-w-2xl rounded-t-2xl sm:rounded-2xl max-h-[92vh] overflow-y-auto p-4 space-y-3" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-bold text-green-900 text-sm">📖 {ficha.titulo}</h3>
          <button onClick={onClose} className="text-gray-400 text-xl px-2 flex-shrink-0" data-testid="ficha-fechar">✕</button>
        </div>
        <div className={fotoUsuario ? "grid grid-cols-2 gap-2" : ""}>
          {fotoUsuario && (
            <div>
              <div className="text-[10px] font-bold text-gray-500 mb-1">SUA FOTO</div>
              <img src={`data:image/jpeg;base64,${fotoUsuario}`} alt="Sua foto" className="rounded-lg w-full max-h-80 object-contain bg-gray-50" data-testid="ficha-foto-usuario" />
            </div>
          )}
          <div>
            <div className="text-[10px] font-bold text-gray-500 mb-1">REFERÊNCIA (ilustração)</div>
            {ficha.imagem_url ? (
              <img src={ficha.imagem_url} alt={ficha.titulo} className="rounded-lg w-full max-h-80 object-contain bg-gray-50" data-testid="ficha-imagem" />
            ) : <div className="text-xs text-gray-400 p-4">Sem ilustração</div>}
          </div>
        </div>
        <p className="text-[10px] text-gray-400">Ilustração didática própria baseada na literatura — não é foto real do patógeno.</p>
        <div className="text-sm text-gray-800 bg-green-50 border border-green-200 rounded-lg p-3 whitespace-pre-wrap" data-testid="ficha-texto">{ficha.texto || ficha.resumo}</div>
        {ficha.fonte && <div className="text-xs text-gray-500" data-testid="ficha-fonte">📚 Fonte: {ficha.fonte}</div>}
      </div>
    </div>
  );
}
